import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { IndexadorAtualizacaoGarantiaCreditoLivre } from 'src/app/model/indexador-atualizacao-garantia-credito-livre';

@Component({
    selector: 'app-indexadores-listagem',
    templateUrl: './indexadores-listagem.component.html',
    styleUrls: ['./indexadores-listagem.component.scss'],
    standalone: false
})
export class IndexadoresListagemComponent implements OnInit, OnChanges {

  @Input() indexadores: IndexadorAtualizacaoGarantiaCreditoLivre[] = [];
  @Input() atributosPaginacao: EntityPagedRequestParameters;

  opcoesPaginacao: number[];
  listaIndexadores: IndexadorAtualizacaoGarantiaCreditoLivre[] = [];
  countIndexadores: number;

  constructor() { }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0]
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.navegar(this.atributosPaginacao)
  }

  public mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.navegar(this.atributosPaginacao)
  }

  public navegar(pesq: EntityPagedRequestParameters) {
    let posInicial: number, posFinal: number;

    posInicial = (pesq.page - 1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.indexadores.length) {
      posFinal = this.indexadores.length
    }

    this.listaIndexadores = this.indexadores.slice(posInicial, posFinal)
    this.countIndexadores = this.indexadores.length
  }

}
